<template>
  <div>
    <h4 class="mb-1">Productos sin Movimiento</h4>
    <p>{{headerInfo}}</p>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: ['headerInfo'],
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {},
    data () {
      return {
        conditionValue: 0
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {},
    computed: {
      vuexReportParameters () {
        return this.$store.state.generalKeyKpiAnalysis.reportParameters
      },
      vuexSelectedReport () {
        return this.$store.state.generalKeyKpiAnalysis.selectedReport
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      // ********************************************** VUEX COMMITS ***************************************************
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/PriceAuditionHeader.vue